import React from "react"
import { HeroSection, MenuSection } from "./components"

const ThucDonThuDuc: React.FC = () => {
  return (
    <>
      <HeroSection />
      <div
        className="w-full bg-cover bg-no-repeat"
        style={{ backgroundImage: "url('/background-img.jpg')" }}
      >
        <MenuSection />
      </div>
    </>
  )
}

export default ThucDonThuDuc
